import {
  GET_INSURANCE_CARRIERS_SUCCESS,
  GET_INSURANCE_CARRIERS_ERROR,
  GET_INSURANCE_CARRIERS
} from "./actionTypes"

const initialState = {
  carriers: [],
  error: null,
  loading: false
}

const insurance_carrier = (state = initialState, action) => {
  switch (action.type) {
    case GET_INSURANCE_CARRIERS:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_INSURANCE_CARRIERS_SUCCESS:
      return {
        ...state,
        carriers: (action.payload || []).sort((a, b) => a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase())),
        loading: false,
        error: null,
      }

    case GET_INSURANCE_CARRIERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default insurance_carrier;
